import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getBusinessRelations } from 'services/businessRelationService';
import { BrSearchDto } from 'types/BrTypes';
import { isNotNullOrUndefined } from 'utils/utils';

export function useFetchBusinessRelations(accountId: string, intermediaryOnly?: boolean, enabled?: boolean) {
  return useQuery<BrSearchDto[], AxiosError>({
    queryKey: ['getBusinessRelations', accountId, intermediaryOnly],
    queryFn: () => getBusinessRelations(accountId, intermediaryOnly),
    retry: 1,
    enabled: isNotNullOrUndefined(enabled) && enabled,
  });
}
